export function vouchersColums({ t, lang }) {
  return [
    {
      Header: '№',
      accessor: 'rowNumber',
      width: 60,
      filterable: false
    },
    {
      Header: t('vouchers_district'),
      accessor: 'queuedRegion',
      Cell: ({ original: { queuedLocation } }) =>
        queuedLocation[`${lang}_name`],
      filterable: false
    },
    {
      Header: t('vouchers_quantity'),
      accessor: 'voucherSum',
      filterable: false
    },
  ];
}
